import { CSSProperties } from 'react'

interface ICoverImageProps {
  uri?: string
  width?: number | string
  height?: number | string
  borderRadius?: number
  objectFit?: CSSProperties['objectFit']
  /** Imagens above-the-fold (banner, poster do player) não devem esperar o
   * lazy loading — o decode continua assíncrono. */
  eager?: boolean
  grayscale?: boolean
  alt?: string
  testID?: string
  /** Ajustes pontuais (radii assimétricos, opacity, cursor). Aplicado por
   * último, então sobrescreve os defaults. */
  style?: CSSProperties
  /** Só tem efeito no nativo (Android fade-in); aceito aqui para os arquivos
   * compartilhados compilarem. */
  fadeDuration?: number
}

// Capas de conteúdo chegam no arquivo original do produtor (fotos de câmera de
// dezenas de megapixels). Um <img> nativo com loading/decoding preguiçosos
// limita o decode às imagens perto do viewport — decodar todas de uma vez
// estoura o limite de memória por aba do Safari em tablets e derruba a página.
export const CoverImage = ({
  uri,
  width = '100%',
  height,
  borderRadius,
  objectFit = 'cover',
  eager,
  grayscale,
  alt = '',
  testID,
  style,
}: ICoverImageProps) => (
  <img
    src={uri || undefined}
    alt={alt}
    data-testid={testID}
    loading={eager ? 'eager' : 'lazy'}
    decoding="async"
    style={{
      width,
      height,
      objectFit,
      borderRadius,
      display: 'block',
      filter: grayscale ? 'grayscale(1)' : undefined,
      ...style,
    }}
  />
)
